import React from 'react';

import { useRetrievalState } from '../state/RetrievalState';
import type { RetrievalContextSource } from '../types/retrieval';

export const useRetrievalExperience = () => {
  const retrieval = useRetrievalState();

  const sortedSources = React.useMemo<RetrievalContextSource[]>(() => {
    return Object.values(retrieval.state.contextSources).sort((a, b) => {
      const left = typeof a.relevanceScore === 'number' ? a.relevanceScore : -1;
      const right = typeof b.relevanceScore === 'number' ? b.relevanceScore : -1;
      return right - left;
    });
  }, [retrieval.state.contextSources]);

  const latestTimelineEntries = React.useMemo(() => {
    return retrieval.state.timeline.slice(-120);
  }, [retrieval.state.timeline]);

  return {
    ...retrieval,
    sortedSources,
    latestTimelineEntries,
  };
};
